import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  FaUser,
  FaBuilding,
  FaCoins,
  FaUserCheck,
  FaUsers,
  FaUserTie,
  FaList,
  FaFileContract,
  FaClock,
  FaRegFileAlt,
  FaStamp,
  FaWallet,
  FaUserFriends,
  FaExchangeAlt,
  FaUtensils,
  FaStore,
  FaHouseUser
} from "react-icons/fa";
import {
  MdOutlineHeadsetMic,
  MdSettings,
  MdLogout,
  MdMenu,
  MdClose,
  MdKeyboardArrowDown,
  MdRestaurantMenu,
  MdSpaceDashboard,
  MdApartment,
  MdPendingActions,
  MdOutlineAssignment,
  MdOutlineInventory2,
  MdOutlineUpdate,
  MdOutlineHomeWork,
  MdOutlineFoodBank,
  MdAutorenew,
  MdInventory2,
  MdOutlineCleaningServices,
  MdOutlineRule
} from "react-icons/md";

import { FaBuildingUser, FaMoneyBillTrendUp, FaPersonWalking } from "react-icons/fa6";
import { BsBank2, BsLightningChargeFill } from "react-icons/bs";
import { RxActivityLog } from "react-icons/rx";
import { FaMoneyBillWave, FaHandshake } from "react-icons/fa";
import { TbCalendarDue, TbCurrentLocation, TbTransferIn } from "react-icons/tb";
import { IoAlarmOutline, IoBasketOutline, IoRestaurantOutline } from "react-icons/io5";
import Images from "../Images";
import tw from "tailwind-styled-components";
import { capitalizeFirstLetter, getRole, getUserType, hasPermission } from "../helpers";
import Config from "../Config";
import { GiTakeMyMoney } from "react-icons/gi";
import { HiOutlineChartBar, HiOutlineFolderOpen, HiOutlineUserGroup, HiOutlineClipboardDocumentList, HiOutlineCalendarDays } from "react-icons/hi2";
import { TbHomeSearch } from "react-icons/tb";
import { GrStorage } from "react-icons/gr";
import { BiPurchaseTag } from "react-icons/bi";
import SideModal from "./SideModal";
import EditProfile from "./Common/EditProfile";

const SideNabar = ({ onLogoutClick }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [showEditProfile, setShowEditProfile] = useState(false);
  const [openSections, setOpenSections] = useState({
    property: false,
    money: false,
    tenants: false,
    quickAction: false,
    landlords: false,
    sales: false,
    food: false,
    foodInventory: false,
  });
  const user = useSelector((state) => state.UserReducer.user);
  const isStampRequired = useSelector((state) => state.IsStampRequiredReducer.isStampRequired);
  const isPayoutEnabled = useSelector((state) => state.IsPayoutEnabledReducer.isPayoutEnabled);

  const selectProperty = useSelector(
    (state) => state.SelectPropertyReducer.selectProperty
  );
  const storedPartner = useSelector((state) => state.SelectedPartnerReducer.selectPartner);
  const propId = selectProperty?.id || 0;
  // const hasPermission = (userPermissions, bitIndex) =>
  // (userPermissions & (1 << bitIndex)) !== 0;

  useEffect(() => {
    setIsMobileOpen(false);
  }, [pathname]);

  const resetTablePagination = () => {
    // Add all your table keys here
    sessionStorage.removeItem("tenant_active_page");
    sessionStorage.removeItem("booking_active_page");
    sessionStorage.removeItem("tenant_expiring_page");
    sessionStorage.removeItem("tenant_movedout_page");
    sessionStorage.removeItem("landlord_list_page");
    sessionStorage.removeItem("dues_page");
    sessionStorage.removeItem("collections_page");
    sessionStorage.removeItem("expenses_page");
    sessionStorage.removeItem("property_list_page");
    // …add all other table keys used in your pages
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMobileOpen && !event.target.closest('.sidebar-container') && !event.target.closest('.mobile-menu-button')) {
        setIsMobileOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isMobileOpen]);

  useEffect(() => {
    if (isMobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileOpen]);

  useEffect(() => {
    const newOpenSections = {
      property: false,
      money: false,
      tenants: false,
      quickAction: false,
      landlords: false,
      sales: false,
      payouts: false,
      food: false,
      foodInventory: false,
    };

    if (pathname === '/finance/collections' || pathname === '/finance/dues' || pathname === '/finance/expenses' || pathname === '/finance/expenses/pending') {
      newOpenSections.money = true;
    } else if (pathname === '/bookings' ||pathname === '/tenants/active' || pathname === '/tenants/expiring-agreements' || pathname === '/tenants/moved-out' || pathname === '/tenants/agreement' || pathname.includes("tenantdetails/l") || pathname === '/landlord/client' || pathname === '/landlord/client/tenants') {
      newOpenSections.tenants = true;
    } else if (pathname === '/staffs' || pathname === '/notice' || pathname === '/extracharges' || pathname === '/vendors' || pathname === '/activity-logs' || pathname.includes("vendors-expense") || pathname === '/staff-commission' || pathname === '/staff-detail' || pathname === '/bank-details' || pathname === '/location' || pathname === '/stamp-paper' || pathname === '/housekeeping') {
      newOpenSections.quickAction = true;
    } else if (pathname === '/landlords' || pathname === '/landlords/payments' || pathname === '/landlord/transactions' || pathname === '/landlord/pending-payouts' || pathname === '/landlord/details') {
      newOpenSections.landlords = true;
    } else if (pathname === '/payouts/beneficiaries' || pathname === '/payouts/transfers' || pathname === '/payouts/staff-wallet' || pathname === '/payouts/autopay') {
      newOpenSections.payouts = true;
    } else if (pathname === '/beds-calendar' || pathname === '/property-list' || pathname === '/property-detail' || pathname === '/beds-view' || pathname === '/properties/agreements' || pathname === '/properties/expiring-agreements' || pathname === '/properties/lockin-tracker' || pathname === '/inventory' || pathname === '/properties/pending-exp' || pathname === '/property-extra-charges' || pathname === '/electricity-bill' || pathname === '/landlord/property-list' || pathname === '/landlord/agreement') {
      newOpenSections.property = true;
    } else if (pathname === '/food-menu' || pathname === '/meal-summary') {
      newOpenSections.food = true;
    } else if (pathname === '/inventory-stock' || pathname === '/stock-transfers' || pathname === '/transfered-items' || pathname === '/purchase-inventory' || pathname === '/food-items' || pathname === '/kitchens') {
      newOpenSections.foodInventory = true;
    }
    else if (pathname === '/leads' || pathname === '/leads/followups' || pathname === '/leads/visits') {
      newOpenSections.sales = true;
    }

    setOpenSections(newOpenSections);
  }, [pathname]);

  const toggleSection = (section) => {
    setOpenSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  const toggleMobileSidebar = () => {
    setIsMobileOpen(!isMobileOpen);
  };
  const handleEditProfileClick = () => {
    setShowEditProfile(true);
  };

  const handleCloseEditProfile = () => {
    setShowEditProfile(false);
  };
  const isOwner =
    user?.userType === Config.USER_TYPE.CLIENT ||
    user?.role === Config.STAFF_ROLES.PARTNER;
  const isAdmin =
    (user?.role === Config.STAFF_ROLES.ADMIN) &&
    user?.userType === Config.USER_TYPE.STAFF;
  const isWarden =
    (user?.role === Config.STAFF_ROLES.WARDEN) &&
    user?.userType === Config.USER_TYPE.STAFF;
  const isFinance =
    user?.role === Config.STAFF_ROLES.FINANCEADMIN &&
    user?.userType === Config.USER_TYPE.STAFF;
  const isITAdmin =
    user?.role === Config.STAFF_ROLES.IT_ADMIN &&
    user?.userType === Config.USER_TYPE.STAFF;
  const isMaintenanceTeam =
    user &&
    user?.role === Config.STAFF_ROLES.MAINTENANCE_SUPERVISOR &&
    user?.userType === Config.USER_TYPE.STAFF;
  const isLandlord = user?.userType === 5;

  //const bookingAllowedClients = [57, 110, 846, 93];
  // const canViewBookings =
  //   bookingAllowedClients.includes(user?.clientId || user?.id);
  //const canViewBookings = true;
  const canViewBookings = isOwner || hasPermission("MANANGE_TENANTS", user);
  const landlordMenuItems = [
    {
      type: "link",
      href: "/landlord/dashboard",
      icon: MdSpaceDashboard,
      label: "Dashboard",
      active: pathname === "/landlord/dashboard"
    },
    {
      type: "dropdown",
      key: "property",
      icon: FaBuilding,
      label: "Properties",
      isOpen: openSections.property,
      onToggle: () => toggleSection("property"),
      items: [
        {
          href: "/landlord/property-list",
          icon: FaList,
          label: "List",
          active: pathname === "/landlord/property-list"
        },

        {
          href: "/landlord/agreement",
          icon: FaFileContract,
          label: "Agreement",
          active: pathname === "/landlord/agreement"
        },
      ]
    },
    {
      type: "dropdown",
      key: "tenants",
      icon: FaUser,
      label: "Tenants",
      isOpen: openSections.tenants,
      onToggle: () => toggleSection("tenants"),
      items: [
        {
          href: "/landlord/client",
          icon: FaBuildingUser,
          label: "Primary Tenants",
          active: pathname === "/landlord/client"
        },
        {
          href: "/landlord/client/tenants",
          icon: FaHouseUser,
          label: "Occupants",
          active: pathname === "/landlord/client/tenants"
        },
      ]
    },
    {
      type: "link",
      href: "/landlord/dues",
      icon: TbCalendarDue,
      label: "Dues",
      active: pathname === "/landlord/dues"
    },
    {
      type: "link",
      href: "/landlord/collections",
      icon: FaCoins,
      label: "Collection",
      active: pathname === "/landlord/collections"
    },
    {
      type: "link",
      href: "/landlord/staffs",
      icon: FaUserTie,
      label: "Staffs",
      active: pathname === "/landlord/staffs"
    },
  ]
  const regularMenuItems = [
    (isOwner || isAdmin || isFinance || isWarden || isITAdmin || isMaintenanceTeam) && {
      type: "link",
      href: "/dashboard",
      icon: MdSpaceDashboard,
      label: "Dashboard",
      active: pathname === "/dashboard"
    },
    hasPermission("MANANGE_LEADS", user) && {
      type: "dropdown",
      key: "sales",
      icon: HiOutlineUserGroup,
      label: "Sales",
      isOpen: openSections.sales,
      onToggle: () => toggleSection("sales"),
      items: [
        {
          href: "/leads",
          icon: HiOutlineUserGroup,
          label: "Leads",
          active: pathname === "/leads"
        },
        {
          href: "/leads/followups",
          icon: MdOutlineUpdate,
          label: "Follow Ups",
          active: pathname === "/leads/followups"
        },
        {
          href: "/leads/visits",
          icon: MdOutlineHomeWork,
          label: "Visits",
          active: pathname === "/leads/visits"
        },
        // {
        //   href: "/leads/qualified",
        //   icon: MdOutlineHomeWork,
        //   label: "Qualified",
        //   active: pathname === "/leads/qualified"
        // }
      ]
    },
    // canViewBookings && {
    //   type: "link",
    //   href: "/bookings",
    //   icon: HiOutlineClipboardDocumentList,
    //   label: "Bookings",
    //   active: pathname === "/bookings"
    // },


    hasPermission("MANANGE_TENANTS", user) && {
      type: "dropdown",
      key: "tenants",
      icon: FaUsers,
      label: "Tenants",
      isOpen: openSections.tenants,
      onToggle: () => toggleSection("tenants"),
      items: [
        {
          type: "link",
          href: "/bookings",
          icon: HiOutlineClipboardDocumentList,
          label: "Bookings",
          active: pathname === "/bookings"
        },
        {
          href: "/tenants/active",
          icon: FaUserCheck,
          label: "Active",
          active: pathname === "/tenants/active"
        },
        {
          href: "/tenants/agreement",
          icon: IoAlarmOutline,
          label: "Expiring Agreement",
          active: pathname === "/tenants/agreement"
        },
        // {
        //   href: "/tenants/expiring-agreements",
        //   icon: IoAlarmOutline,
        //   label: "Expiring Agreement",
        //   active: pathname === "/tenants/expiring-agreements"
        // },
        {
          href: "/tenants/moved-out",
          icon: FaPersonWalking,
          label: "Moved Out",
          active: pathname === "/tenants/moved-out"
        },

      ]
    },

    // Properties
    hasPermission("MANANGE_EXPENSES", user) ||
      hasPermission("MANANGE_EXTRACHARGES", user) ||
      hasPermission("MANANGE_INVENTORY", user)
      ?
      {
        type: "dropdown",
        key: "property",
        icon: FaBuilding,
        label: "Properties",
        isOpen: openSections.property,
        onToggle: () => toggleSection("property"),
        items: [
          hasPermission("MANANGE_INVENTORY", user) && {
            href: "/property-list",
            icon: MdApartment,
            label: "List",
            active: pathname === "/property-list"
          },
          hasPermission("MANANGE_INVENTORY", user) && {
            href: "/properties/agreements",
            icon: FaFileContract,
            label: "Agreements",
            active: pathname === "/properties/agreements"
          },
          hasPermission("MANANGE_INVENTORY", user) && {
            href: "/beds-calendar",
            icon: HiOutlineCalendarDays,
            label: "Bed Calendar",
            active: pathname === "/beds-calendar"
          },
          // hasPermission("MANANGE_EXPENSES", user) && {
          //   href: "/properties/pending-exp",
          //   icon: MdPendingActions,
          //   // label: "Recurring Expenses",
          //   label: "Pending Expenses",
          //   active: pathname === "/properties/pending-exp"
          // },
        ]
      } : null,

    hasPermission("MANANGE_DUES", user) ||
      hasPermission("MANANGE_COLLECTIONS", user) ||
      hasPermission("MANANGE_EXPENSES", user)
      ?
      {
        type: "dropdown",
        key: "money",
        icon: FaWallet,
        label: "Finance",
        isOpen: openSections.money,
        onToggle: () => toggleSection("money"),
        items: [
          hasPermission("MANANGE_DUES", user) && {
            href: "/finance/dues",
            icon: TbCalendarDue,
            label: "Dues",
            active: pathname === "/finance/dues"
          },
          hasPermission("MANANGE_COLLECTIONS", user) && {
            href: "/finance/collections",
            icon: GiTakeMyMoney,
            label: "Collection",
            active: pathname === "/finance/collections"
          },
          // hasPermission("MANANGE_EXPENSES", user) && {
          //   href: "/finance/refund",
          //   icon: RiRefund2Fill,
          //   label: "Refunds",
          //   active: pathname === "/finance/refund"
          // },
          hasPermission("MANANGE_EXPENSES", user) && {
            href: "/finance/expenses",
            icon: FaMoneyBillWave,
            label: "Expenses",
            active: pathname === "/finance/expenses"
          },


        ]
      } : null,

    isPayoutEnabled === Config.PAYOUT_ENABLED.YES && {
      type: "dropdown",
      key: "payouts",
      icon: FaWallet,
      label: "Payouts",
      isOpen: openSections.payouts,
      onToggle: () => toggleSection("payouts"),
      items: [
        {
          href: "/payouts/beneficiaries",
          icon: FaUserFriends,
          label: "Beneficiaries",
          active: pathname === "/payouts/beneficiaries"
        },
        {
          href: "/payouts/transfers",
          icon: FaExchangeAlt,
          label: "Transfers",
          active: pathname === "/payouts/transfers"
        },
        isOwner && {
          href: "/payouts/staff-wallet",
          icon: FaWallet,
          label: "Staff Wallet",
          active: pathname === "/payouts/staff-wallet"
        },
        {
          href: "/payouts/autopay",
          icon: MdAutorenew,
          label: "Manage Autopay",
          active: pathname === "/payouts/autopay"
        },
      ]
    },

    hasPermission("MANANGE_REQUESTS", user) && {
      type: "link",
      href: "/requests",
      icon: MdOutlineAssignment,
      label: "Request",
      active: pathname === "/requests"
    },
    hasPermission("MANANGE_COMPLAINTS", user) && {
      type: "link",
      href: "/complaints",
      icon: MdOutlineHeadsetMic,
      label: "Complaints",
      active: pathname === "/complaints"
    },
    // hasPermission("MANANGE_COMPLAINTS", user) && {
    //   type: "link",
    //   href: "/complaints/assignment-rules",
    //   icon: MdOutlineRule,
    //   label: "Assignment Rules",
    //   active: pathname === "/complaints/assignment-rules",
    // },
    // hasPermission("MANANGE_LEADS", user) && {
    //   type: "link",
    //   href: "/leads",
    //   icon: HiOutlineUserGroup,
    //   label: "Leads",
    //   active: pathname === "/leads"
    // },

    //(user.parentId === null && storedPartner?.clientId === user.id) && {
    // Food Menu - New standalone dropdown
    hasPermission("MANAGE_FOOD", user) && {
      type: "dropdown",
      key: "food",
      icon: MdRestaurantMenu,
      label: "Food",
      isOpen: openSections.food,
      onToggle: () => toggleSection("food"),
      items: [
        {
          href: "/food-menu",
          icon: FaUtensils,
          label: "Food Menu",
          active: pathname === "/food-menu"
        },
        {
          href: "/meal-summary",
          icon: HiOutlineChartBar,
          label: "Meal Summary",
          active: pathname === "/meal-summary"
        },
      ]
    },

    // Quick Action
    hasPermission("MANANGE_STAFF", user) ||
      hasPermission("MANANGE_LEADS", user) ||
      hasPermission("MANAGE_VENDOR", user) ||
      hasPermission("MANANGE_SENDNOTICES", user) ||
      hasPermission("MANANGE_EXTRACHARGES", user) ||
      hasPermission("MANANGE_LEADS", user) ||
      hasPermission("MANAGE_HOUSEKEEPING", user)
      ?
      {
        type: "dropdown",
        key: "quickAction",
        icon: BsLightningChargeFill,
        label: "Quick Action",
        isOpen: openSections.quickAction,
        onToggle: () => toggleSection("quickAction"),
        items: [
          // hasPermission("MANANGE_LEADS", user) && {
          //   href: "/leads",
          //   icon: FaUser,
          //   label: "Leads",
          //   active: pathname === "/leads"
          // },
          hasPermission("MANANGE_STAFF", user) && {
            href: "/staffs",
            icon: FaUserTie,
            label: "Staffs",
            active: pathname === "/staffs"
          },
          hasPermission("MANANGE_STAFF", user) && {
            href: "/staff-commission",
            icon: GiTakeMyMoney,
            label: "Commission",
            active: pathname === "/staff-commission"
          },
          hasPermission("MANAGE_VENDOR", user) && {
            href: "/vendors",
            icon: FaStore,
            label: "Vendors",
            active: pathname === "/vendors"
          },
          hasPermission("MANANGE_TENANTS", user) && {
            href: "/activity-logs",
            icon: RxActivityLog,
            label: "Activity Logs",
            active: pathname === "/activity-logs"
          },
          // hasPermission("MANANGE_SENDNOTICES", user) && {
          //   href: "/notice",
          //   icon: GrAnnounce,
          //   label: "Notice",
          //   active: pathname === "/notice"
          // },
          hasPermission("MANANGE_EXTRACHARGES", user) && {
            href: "/extracharges",
            icon: FaMoneyBillTrendUp,
            label: "Extra Charges",
            active: pathname === "/extracharges"
          },
          hasPermission("MANANGE_BANKS", user) && {
            href: "/bank-details",
            icon: BsBank2,
            label: "Banks",
            active: pathname === "/bank-details"
          },
          // {
          //   href: "/food-menu",
          //   icon: FaBowlFood,
          //   label: "Food Menu",
          //   active: pathname === "/food-menu"
          // },
          // {
          //   href: "/meal-summary",
          //   icon: IoFastFood,
          //   label: "Meal Summary",
          //   active: pathname === "/meal-summary"
          // },
          hasPermission("MANANGE_INVENTORY", user) &&
          {
            href: "/location",
            icon: TbCurrentLocation,
            label: "Locations",
            active: pathname === "/location"
          },
          hasPermission("MANAGE_HOUSEKEEPING", user) && {
            href: "/housekeeping",
            icon: MdOutlineCleaningServices,
            label: "Housekeeping",
            active: pathname === "/housekeeping"
          },
          ...(isStampRequired === Config.STAMP_REQUIRED.YES ? [{
            href: "/stamp-paper",
            icon: FaStamp,
            label: "Stamp Papers",
            active: pathname === "/stamp-paper"
          }] : [])
        ].filter(Boolean)
      } : null,

    hasPermission("MANAGE_INVENTORY", user) && {
      type: "dropdown",
      key: "foodInventory",
      icon: MdInventory2,
      label: "Inventory",
      isOpen: openSections.foodInventory,
      onToggle: () => toggleSection("foodInventory"),
      items: [
        {
          href: "/stock-transfers",
          icon: TbTransferIn,
          label: "Transfers",
          active: pathname === "/stock-transfers"
        },
        {
          href: "/purchase-inventory",
          icon: BiPurchaseTag,
          label: "Purchases",
          active: pathname === "/purchase-inventory"
        },
        {
          href: "/inventory-stock",
          icon: GrStorage,
          label: "Stock",
          active: pathname === "/inventory-stock"
        },
        {
          href: "/food-items",
          icon: IoBasketOutline,
          label: "Items",
          active: pathname === "/food-items"
        },
        {
          href: "/kitchens",
          icon: IoRestaurantOutline,
          label: "Kitchens",
          active: pathname === "/kitchens"
        },
      ]
    },
    hasPermission("MANANGE_LANDLORD", user) && {
      type: "dropdown",
      key: "landlords",
      icon: FaBuildingUser,
      label: "Landlords",
      isOpen: openSections.landlords,
      onToggle: () => toggleSection("landlords"),
      items: [
        {
          href: "/landlords",
          icon: FaList,
          label: "List",
          active: pathname === "/landlords"
        },
        {
          href: "/landlords/payments",
          icon: FaCoins,
          label: "Payments",
          active: pathname === "/landlords/payments"
        },
        {
          href: "/landlord/pending-payouts",
          icon: FaClock,
          label: "Pending Payouts",
          active: pathname === "/landlord/pending-payouts"
        }
      ]
    },
    hasPermission("MANANGE_PROPERTY_ASSETS", user) && {
      type: "link",
      href: "/assets",
      icon: MdOutlineInventory2,
      label: "Asset Management",
      active: pathname === "/assets"
    },
    (storedPartner?.clientId === user.id) && {
      type: "link",
      href: "/partners",
      icon: FaHandshake,
      label: "Partners",
      active: pathname === "/partners"
    },
    // (isOwner || isAdmin || isFinance) && {
    hasPermission("MANANGE_REPORTS", user) && {
      type: "link",
      href: "/reports",
      icon: FaRegFileAlt,
      label: "Reports",
      active: pathname === "/reports"
    },
    hasPermission("MANAGE_DOCUMENTS", user) && {
      type: "link",
      href: "/documents-vault",
      icon: HiOutlineFolderOpen,
      label: "Document Vault",
      active: pathname === "/documents-vault"
    },
    (isOwner || isAdmin || isFinance) && {
      type: "link",
      href: "/settings",
      icon: MdSettings,
      label: "Settings",
      active: pathname === "/settings"
    },

  ];
  const menuItems = isLandlord ? landlordMenuItems : regularMenuItems;
  const cleanMenu = (menus) => {
    return menus
      .filter(Boolean) // remove false, null, undefined
      .map((item) => {
        if (item.type === "dropdown" && Array.isArray(item.items)) {
          return {
            ...item,
            items: cleanMenu(item.items), // recursively clean submenus
          };
        }
        return item;
      });
  };

  const safeMenuItems = cleanMenu(menuItems);

  const MenuButton = ({ children, isActive, onClick, asLink = false, href = "#", className = "" }) => {
    if (asLink) {
      return (
        <MenuLink
          to={href}
          $isActive={isActive}
          className={className}
        // onClick={() => {
        //   resetTablePagination();   // RESET page indexes on navigation
        // }}
        >
          {children}
        </MenuLink>
      );
    }

    return (
      <MenuButtonWrapper
        onClick={onClick}
        $isActive={isActive}
        className={className}
      >
        {children}
      </MenuButtonWrapper>
    );
  };

  const renderMenuItem = (item) => {
    if (item.type === "link") {
      return (
        <li key={item.href}>
          <MenuButton
            asLink
            href={item.href}
            isActive={item.active}
          >
            <item.icon className="h-4 w-4 flex-shrink-0" />
            <MenuItemLabel
              $isCollapsed={isCollapsed}
              $isMobileOpen={isMobileOpen}
            >
              {item.label}
            </MenuItemLabel>
          </MenuButton>
        </li>
      );
    }

    if (item.type === "dropdown") {
      return (
        <li key={item.key} className="mb-1">
          <MenuButton
            onClick={item.onToggle}
            isActive={item.active}
            className="justify-between"
          >
            <div className="flex items-center gap-3">
              <item.icon className="h-4 w-4 flex-shrink-0" />
              <MenuItemLabel
                $isCollapsed={isCollapsed}
                $isMobileOpen={isMobileOpen}
              >
                {item.label}
              </MenuItemLabel>
            </div>
            <DropdownIcon
              $isOpen={item.isOpen}
              $isCollapsed={isCollapsed}
              $isMobileOpen={isMobileOpen}
            />
          </MenuButton>
          {item.isOpen && (
            <DropdownMenu
              $isCollapsed={isCollapsed}
              $isMobileOpen={isMobileOpen}
            >
              {item.items.map((subItem) => (
                <li key={subItem.href}>
                  <MenuButton
                    asLink
                    href={subItem.href}
                    isActive={subItem.active}
                    className="pl-3"
                  >
                    <subItem.icon className="h-4 w-4 flex-shrink-0" />
                    <span>{subItem.label}</span>
                  </MenuButton>
                </li>
              ))}
            </DropdownMenu>
          )}
        </li>
      );
    }
  };
  const userRole = getRole(user?.userRole);
  const userType = getUserType(user?.userType);
  const SidebarFooter = () => {
    return (
      <FooterContainer>
        {/* User Info Section */}
        <div className="flex justify-between p-1.5 rounded-lg bg-gray-50">

          <UserInfoContainer
          // onClick={user.userType === 1 ? handleEditProfileClick : undefined}
          // $clickable={user.userType === 1}
          >
            <UserAvatar>
              <FaUser className="h-4 w-4" />
            </UserAvatar>
            {(!isCollapsed || isMobileOpen) && (
              <UserDetails>
                <UserName>{user?.name ? capitalizeFirstLetter(user?.name) : "User"}</UserName>
                {user.userRoler ?
                  <UserRole>{userRole}</UserRole> :
                  <UserRole>{userType}</UserRole>}
              </UserDetails>
            )}
          </UserInfoContainer>

          {/* Logout Button */}
          {/* <MenuButton onClick={onLogoutClick}> */}
          <button className="flex justify-end items-center w-1/4" onClick={onLogoutClick}>
            <MdLogout className="h-4 w-4 flex-shrink-0 text-rose-500" title="Logout" />
          </button>
          {/* <MenuItemLabel
            $isCollapsed={isCollapsed}
            $isMobileOpen={isMobileOpen}
          >
            Logout
          </MenuItemLabel> */}
          {/* </MenuButton> */}
        </div>
      </FooterContainer>
    );
  };
  return (
    <>
      <MobileMenuButton
        className="mobile-menu-button"
        onClick={toggleMobileSidebar}
      >
        {isMobileOpen ? <MdClose className="h-5 w-5" /> : <MdMenu className="h-5 w-5" />}
      </MobileMenuButton>

      {isMobileOpen && (
        <MobileOverlay onClick={() => setIsMobileOpen(false)} />
      )}

      <SidebarContainer
        $isCollapsed={isCollapsed}
        $isMobileOpen={isMobileOpen}
      >
        <SidebarHeader>
          <div className="flex items-center">
            {(!isCollapsed || isMobileOpen) && (
              <div className="flex items-center gap-3">
                <Logo src={Images.Logo} alt="Kipinn Logo" />
                <div className="hidden md:flex items-center gap-3">
                  <div className="h-4 w-px bg-gray-300" />
                  <span className="text-sm font-medium text-gray-700">
                    PG & Coliving
                  </span>
                </div>
              </div>
            )}
          </div>

          <MobileCloseButton
            onClick={() => setIsMobileOpen(false)}
          >
            <MdClose className="h-4 w-4" />
          </MobileCloseButton>
        </SidebarHeader>

        <SidebarContent>
          <SidebarNav>
            <SidebarMenu>
              {safeMenuItems.map(renderMenuItem)}
            </SidebarMenu>
          </SidebarNav>
        </SidebarContent>
        <SidebarFooter />

      </SidebarContainer>

      {showEditProfile && (
        <SideModal
          isOpen={showEditProfile}
          onClose={() => setShowEditProfile(false)}
        >
          <EditProfile
            handleClose={() => setShowEditProfile(false)}
          />
        </SideModal>
      )}
    </>
  );
};

// Styled Components
const MobileMenuButton = tw.button`lg:hidden fixed top-3 left-4 z-10 p-2 bg-white rounded-lg shadow-lg border border-gray-200 text-gray-600 hover:bg-gray-100`;
const MobileOverlay = tw.div`lg:hidden fixed inset-0 bg-black bg-opacity-50 z-5 transition-opacity duration-300`;
const SidebarContainer = tw.div`no-scrollbar sidebar-container flex flex-col bg-white transition-all duration-300 h-screen z-10 ${props => props.$isCollapsed ? 'w-16' : 'w-60'} lg:static lg:translate-x-0 lg:shadow-none fixed top-0 left-0 ${props => props.$isMobileOpen ? 'translate-x-0 shadow-2xl' : '-translate-x-full'} ${props => props.$isCollapsed && !props.$isMobileOpen ? 'lg:w-16' : ''}`;
// const SidebarHeader = tw.div`sidebar-header flex items-center justify-between p-4 border-b border-gray-200 min-h-16`;
const SidebarHeader = tw.div`sidebar-header flex items-center justify-between p-4 min-h-16`;
const Logo = tw.img`w-20`;
const MobileCloseButton = tw.button`lg:hidden flex items-center justify-center w-8 h-8 rounded-md border border-gray-200 bg-transparent text-gray-600 cursor-pointer transition-all duration-200 hover:bg-gray-100 hover:text-gray-900`;
const SidebarContent = tw.div`sidebar-content flex-1 overflow-y-auto p-2 no-scrollbar`;
const SidebarNav = tw.nav`sidebar-nav h-full`;
const SidebarMenu = tw.ul`sidebar-menu list-none p-0 m-0`;
const SidebarFooter = tw.div`sidebar-footer p-4 border-t border-gray-200 min-h-16`;
const MenuButtonWrapper = tw.button`flex items-center gap-3 w-full p-3 text-base rounded-md transition-all duration-200 hover:text-primary-color ${props => props.$isActive ? 'text-primary-color' : 'text-gray-600'} ${props => props.className || ''}`;
const MenuLink = tw(Link)`flex items-center gap-3 w-full p-3 text-base rounded-md transition-all duration-200 hover:text-primary-color ${props => props.$isActive ? 'text-primary-color' : 'text-gray-600'} ${props => props.className || ''}`;
const DropdownIcon = tw(MdKeyboardArrowDown)`h-4 w-4 transition-transform ${props => props.$isOpen ? "rotate-180" : ""} ${props => props.$isCollapsed && !props.$isMobileOpen ? 'lg:hidden' : ''} ${props => props.$isMobileOpen ? 'block' : 'lg:block'}`;
const DropdownMenu = tw.ul`ml-4 mt-1 space-y-1 border-l-2 border-gray-200 pl-3 ${props => props.$isCollapsed && !props.$isMobileOpen ? 'lg:hidden' : ''} ${props => props.$isMobileOpen ? 'block' : 'lg:block'}`;
const MenuItemLabel = tw.span`${props => props.$isCollapsed && !props.$isMobileOpen ? 'lg:hidden' : ''} ${props => props.$isMobileOpen ? 'block' : 'lg:block'}`;
const MenuIcon = tw.div`h-4 w-4 flex-shrink-0`;

const FooterContainer = tw.div`p-4 border-t border-gray-200`;
// const UserInfoContainer = tw.div`flex items-center gap-3 w-3/4 cursor-pointer`;
const UserInfoContainer = tw.div`
    flex items-center gap-3 w-3/4
    ${({ $clickable }) => $clickable && 'cursor-pointer'}
`;
const UserAvatar = tw.div`flex items-center justify-center w-8 h-8 rounded-full bg-primary-color text-white flex-shrink-0`;
const UserDetails = tw.div`flex flex-col min-w-0`;
const UserName = tw.span`text-sm font-medium text-gray-900 truncate`;
const UserRole = tw.span`text-xs text-gray-500 truncate`;
export default SideNabar;